<template>
    <div>
        <el-card>
            <div slot="header">
                <el-input v-model="searchVal" style="width: 320px" placeholder="请输入">
                    <template slot="prepend">指定用户</template>
                </el-input>
                <el-button style="margin-left: 10px" type="primary" @click="searchFunc">搜索</el-button>
            </div>
            <div>
                <strong style="padding-right: 50px">搜索结果</strong>
                <p class="common-text-item" v-text="`用户ID：${userIdShow}`"></p>
                <p class="common-text-item" v-text="`用户昵称：${userName}`"></p>
                <el-button type="primary" size="mini" :disabled="!Boolean(userIdShow)" @click="addFunc">添加</el-button>
            </div>
        </el-card>

        <div class="common-table">
            <el-table
                    height="100%"
                    row-key="id"
                    :data="msgReceiveUserList.beanList">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="用户ID" align="center" prop="randomId"/>
                <el-table-column label="用户昵称" align="center" prop="nickName"/>
                <el-table-column width="120px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="removeFunc(scope.row.id)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :page-size="20"
                :pager-count="5"
                :total="msgReceiveUserList.total"
                :current-page="currentPage"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                userId: '',
                userIdShow: '',
                userName: '',
                currentPage: 1
            }
        },
        computed: {
            ...mapState('user', ['msgReceiveUserList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('user', ['getUserInfo', 'getMsgReceiveUserList', 'addMsgReceiveUser', 'deleteMsgReceiveUser']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getMsgReceiveUserList({
                    content: '',
                    page
                }).then(() => {
                    this.loading = false;
                })
            },
            searchFunc() {
                if (!this.searchVal) {
                    this.$message.error('请输入搜索用户')
                }
                this.getUserInfo({
                    content: this.searchVal
                }).then(res => {
                    let data = res.data;
                    if (data.length) {
                        this.userId = data[0].userId;
                        this.userIdShow = data[0].userIdShow;
                        this.userName = data[0].nickName;
                    } else {
                        this.$message.info('没有该用户')
                    }
                })
            },
            addFunc() {
                this.addMsgReceiveUser({
                    userId: this.userIdShow
                }).then(() => {
                    this.$message.success('添加成功');
                    this.getList(this.currentPage);
                })
            },
            removeFunc(id) {
                this.$confirm('确认删除吗？','提示',{
                    type:'info'
                }).then(()=>{
                    this.deleteMsgReceiveUser({
                        id
                    }).then(() => {
                        this.$message.success('删除成功');
                        this.getList(this.currentPage);
                    })
                }).catch(()=>{})
            }
        }
    }
</script>
<style lang="scss" scoped>
    .common-text-item {
        min-width: 200px;
        padding-top: 0;
    }
</style>